import { SecondLevelHeader } from "@/components/SecondLevelHeader";
import { t } from "@repo/translation";

export const WORKSPACE_TAB = "WORKSPACE";
export const PROJECTS_TAB = "PROJECTS";

export const ProjectSecondLevelHeader = ({
  activeTabPanelId,
}: {
  activeTabPanelId: typeof WORKSPACE_TAB | typeof PROJECTS_TAB;
}) => {
  return (
    <SecondLevelHeader
      button={activeTabPanelId === WORKSPACE_TAB}
      activeTabPanelId={activeTabPanelId}
      tabs={[
        {
          label: t("label.workspace"),
          tabPanelId: WORKSPACE_TAB,
          url: "/workspace",
        },
        {
          label: t("label.projects"),
          tabPanelId: PROJECTS_TAB,
          url: "/",
        },
      ]}
      line={activeTabPanelId === PROJECTS_TAB}
    />
  );
};
